import { css } from "styled-components";
import { cssFontFamilySansSerif } from "../../../../skins/league-client/mixins/typography";
export const riotProductSkin = (chroma, paletteTokens) => css `
  ${chroma.typography.body2};
  ${cssFontFamilySansSerif}

  & .SelectTrigger {
    display: inline-flex;
    align-items: center;
    padding: 0 16px;
    font-size: 13px;
    line-height: 1;
    height: 48px;
    gap: 5px;
    background-color: #333;
    color: #ece8e1;
    width: 100%;
    max-width: 512px;
    justify-content: space-between;
    outline: 0;
    ${chroma.typography.body2};
  }

  & .SelectTrigger > span {
    color: #ece8e1;
  }

  & .SelectTrigger > span > span {
    background-color: #ece8e1;
  }

  & .SelectTrigger:hover {
    background-color: ${paletteTokens.bladebg2};
  }

  & .SelectTrigger:focus {
    box-shadow: 0 0 0 2px black;
  }

  & .SelectTrigger[data-placeholder] {
    color: #ece8e1;
  }
`;
//# sourceMappingURL=index.js.map